import React from 'react';
import { Text } from '@this/components/shared/ui/data_displays/typography';

export const REPOSITORY_UNAVAILABLE_MESSAGE =
  'この商材はご利用設定がされていません。詳しくは自社の管理者にお問い合わせください。';

const RepositoryUnavailableNotice: React.FC<{ className?: string }> = ({ className }) => (
  <Text color="danger" className={className}>
    この商材はご利用設定がされていません。
    <br />
    詳しくは自社の管理者にお問い合わせください。
  </Text>
);

export default RepositoryUnavailableNotice;
